import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { useLanguage } from '../LanguageContext';
import TickIcon from '../icons/TickIcon';
import pages from '../pages';

export default function SuccessPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  // Find the Q&A page index in the pages array
  const qaIndex = pages.findIndex((p) => p.key === 'qa');

  const goToQa = () => {
    navigate('/', { state: { pageIndex: qaIndex !== -1 ? qaIndex : 2 } });
  };

  const goHome = () => {
    navigate('/');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center font-normal"
    >
      {/* Checkmark circle */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{
          delay: 0.1,
          type: 'spring',
          stiffness: 260,
          damping: 20,
        }}
        className="mb-8 flex items-center justify-center w-20 h-20 rounded-full bg-wedding-offwhite border border-wedding-floral"
      >
        <TickIcon className="w-10 h-10 text-rose-accent" />
      </motion.div>

      {/* Title */}
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25, duration: 0.4 }}
        className="text-3xl text-content-h1 leading-snug"
      >
        {t('rsvp_form.success_title')}
      </motion.p>

      {/* Subtitle */}
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.4 }}
        className="mt-3 text-lg text-content-c1"
      >
        {t('rsvp_form.success_subtitle')}
      </motion.p>

      {/* Buttons */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.4 }}
        className="mt-10 flex flex-col gap-3 w-full max-w-xs"
      >
        <button onClick={goToQa} className="btn-success-primary">
          {t('rsvp_form.success_go_qa')}
        </button>
        <button onClick={goHome} className="btn-success-secondary">
          {t('rsvp_form.success_go_home')}
        </button>
      </motion.div>
    </motion.div>
  );
}
